export const loginUsername = ({ username }) => {
  return username || null;
};

export const lastUsername = ({ username }) => {
  return username || null;
};

export const loginFullName = ({ firstName, lastName }) => {
  return [firstName, lastName]
    .filter(n => !!n)
    .join(" ")
    .trim();
};

export const loginFirstName = ({ firstName }) => {
  return firstName || null;
};

export const loginExtraInfo = state => {
  return {
    firstName: state.firstName,
    lastName: state.lastName,
    birthday: state.birthday,
    phoneNumber: state.phoneNumber,
    gender: state.gender,
    subscribed: state.subscribed,
    avatarUrl: state.avatarUrl,
  };
};

export const loginAvatarUrl = ({ avatarUrl }) => {
  return avatarUrl || null;
};

export const isAuthenticated = ({ user }) => {
  return !!user;
};

export const user = ({ user }) => {
  return user;
};
